module.exports = "query userBrandEducation{userBrandEducation{userId completionCount allCatalogCount brandCatalogCount completedCourses}}"